import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { colors } from '../../../../theme';

export type StyleProps = {
  backgroundColor: string;
};

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    instructions: {
      display: 'inline',
      color: colors.madison,
      fontSize: 14,
      lineHeight: '24px',
      fontWeight: 500,
    },
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      width: '100%',
      marginTop: 10,
      backgroundColor: ({ backgroundColor }: StyleProps): string =>
        backgroundColor,
      borderRadius: theme.spacing(1.25),
      border: '1px solid #DADADA',
      paddingTop: 24,
      paddingBottom: 24,
      paddingRight: 14,
      paddingLeft: 10,
    },
    px: {
      color: colors.bright_turquoise,
    },
    autoPxMessge: {
      width: '100%',
      paddingTop: 10,
    },
    lightBlue: {
      color: colors.bright_turquoise,
    },
    promoText: {
      fontWeight: 500,
    },
    verticalLine: {
      borderLeft: '2px solid #DADADA',
      height: 40,
    },
    item: {
      margin: theme.spacing(0, 2),
      [theme.breakpoints.down('md')]: {
        margin: theme.spacing(0, 1),
      },
    },
    itemHelpCard: {
      margin: theme.spacing(0, 1),
    },
    text: {
      fontSize: 13,
      textAlign: 'start',
      fontWeight: 800,
      marginLeft: 8,
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.spacing(1.5),
        fontWeight: 600,
      },
    },
  }),
);
